import {Autoplay, Pagination, Swiper} from 'swiper';

export class CustomSlider {
    constructor()
    {
        new Swiper('.slider-custom', {
            modules: [Pagination, Autoplay],
            loop: true,
            centeredSlides: true,
            pagination: {
                el: '.slider-custom-pagination',
                clickable: true,
            },
            autoplay: {
                delay: 5000,
            },
        });
    }
}



// WEBPACK FOOTER //
// ./js/util/slider.js